import Title from 'components/Title'
import { FormattedMessage } from 'react-intl'
import InputLabel from 'ui/InputLabel'
import Separator from 'ui/Separator'
import { formatPercentage } from 'utils/functions/number'
import { instrumentFieldIsDefined } from 'utils/functions/transactions'
import theme from 'utils/theme'
import { CreateTransactionFormValues } from 'utils/types/updateForm'
import UpdateText from 'containers/UpdatesV2/ShowUpdateContent/UpdateText'
import {
  Content,
  Row,
  TransactionContent,
} from '../ShowTransactionContent.styles'

const FundInvestmentInstrumentContent = ({
  transaction,
}: {
  transaction: CreateTransactionFormValues
}) => {
  return (
    <TransactionContent>
      <Row gridColumn="1 / 3">
        <Title
          title={<FormattedMessage id="transactions.additionalInformation" />}
          color={theme.colors.lightGray}
        />
        <Separator />
      </Row>

      {instrumentFieldIsDefined(transaction.description) && (
        <Row gridColumn="1 / 3">
          <InputLabel marginLeft="1.4rem">
            <FormattedMessage id="updates.description" />
          </InputLabel>
          <Content>
            <UpdateText text={transaction.description} />
          </Content>
        </Row>
      )}

      {instrumentFieldIsDefined(transaction.annualManagementFee) && (
        <Row>
          <InputLabel marginLeft="1.4rem">
            <FormattedMessage id="transactions.annualManagementFee" />
          </InputLabel>
          <Content capitalize>
            {formatPercentage(transaction.annualManagementFee)}
          </Content>
        </Row>
      )}

      {instrumentFieldIsDefined(transaction.carry) && (
        <Row>
          <InputLabel marginLeft="1.4rem">
            <FormattedMessage id="transactions.carry" />
          </InputLabel>
          <Content capitalize>{formatPercentage(transaction.carry)}</Content>
        </Row>
      )}

      {instrumentFieldIsDefined(transaction.carryHurdleRate) && (
        <Row>
          <InputLabel marginLeft="1.4rem">
            <FormattedMessage id="transactions.carryHurdleRate" />
          </InputLabel>
          <Content capitalize>
            {formatPercentage(transaction.carryHurdleRate)}
          </Content>
        </Row>
      )}

      <Row>
        <InputLabel marginLeft="1.4rem">
          <FormattedMessage id="transactions.drawdownAgainstCommitment" />
        </InputLabel>
        <Content capitalize>
          <FormattedMessage
            id={
              transaction.drawdownAgainstCommitment ? 'common.yes' : 'common.no'
            }
          />
        </Content>
      </Row>
    </TransactionContent>
  )
}

export default FundInvestmentInstrumentContent
